/**
 * The notification socket's connection state, shared by value instead of by
 * opening another socket. `useWebSocket` (mounted once, in App) publishes it;
 * anything else that only needs to know whether live frames are arriving
 * (the assistant panel's polling cadence) reads it here. Before this, the
 * shell called `useWebSocket()` a second time just for `isConnected`, which
 * opened a second socket and delivered every assistant frame twice.
 */
import { useSyncExternalStore } from 'react'

let connected = false
const listeners = new Set()

export function setSocketConnected(value) {
  const next = Boolean(value)
  if (next === connected) return
  connected = next
  listeners.forEach((listener) => listener())
}

export function getSocketConnected() {
  return connected
}

function subscribe(listener) {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

/** @returns {boolean} whether the notification socket is currently open */
export function useSocketConnected() {
  return useSyncExternalStore(subscribe, getSocketConnected, getSocketConnected)
}

